export default function Facilities() {
  const facilities = [
    {
      name: '교육시설',
      description: '아이의 안전과 학습 몰입을 최우선으로 설계한 교육 환경',
      features: ['쾌적한 창의 트레이닝 공간', '충격 흡수 바닥재 및 안전 마감 설계', '소수정원제 수업(선생님2명/학생6명)', '공기질 관리 및 환기 시스템 구축'],
      image: 'https://static.readdy.ai/image/fd4cc5ead5d87929353b34de6a5078e9/8b9ab4e178663691d68de84781de88ee.jpeg'
    }
  ];

  return (
    <section id="facilities" className="py-12 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            시설 안내
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            아이들의 안전과 편의를 최우선으로 생각한 최신 시설을 갖추고 있습니다
          </p>
        </div>

        <div className="space-y-8 md:space-y-12">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              } gap-6 md:gap-8 items-center`}
            >
              <div className="w-full md:w-1/2">
                <div className="relative h-64 md:h-96 rounded-2xl overflow-hidden shadow-xl group">
                  <img
                    src={facility.image}
                    alt={facility.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-4 md:space-y-6">
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">{facility.name}</h3>
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">{facility.description}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                  {facility.features.map((feature, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-2 md:gap-3 bg-orange-50 p-3 md:p-4 rounded-lg"
                    >
                      <i className="ri-check-line text-orange-500 text-lg md:text-xl flex-shrink-0"></i>
                      <span className="text-xs md:text-sm font-medium text-gray-800">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
